// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    padding-top: 135px;
    color: #000;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    top: 0;
    width: 100%;
    
    display: flex;
   
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 0;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    filter: grayscale(20%);
    box-sizing: border-box;
  }
  
  .input-group {
    margin-bottom: 15px;
  }
  
  .login-input {
    width: 327px;
    height: 60px;
    padding: 16px 24px 16px 24px;
    align-items: center;
    flex-shrink: 0;
    border-radius: 16px;
    border: 2px solid var(--Off-Black, #1d1d1f);
    background: var(--Off-White, #fafafc);
    font-size: 24px;
  }
  .login-input:focus{
  border-color: #922c2e;
  border: 2px solid #922c2e;
  }
  input:focus {
      outline:none;
  }
  .login-button {
    width: 325px;
    height: 60px;
    display: inline-flex;
    padding: 14px 32px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    border-radius: 16px;
    background: var(--Off-Black, #1d1d1f);
  
    color: var(--Off-White, #fafafc);
    /* Heading/H3 Bold */
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    /* 133.333% */
  }
  
  .login-button:hover {
    background-color: #922c2e;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,MAAM;IACN,WAAW;;IAEX,aAAa;;IAEb,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,eAAe;EACjB;EACA;EACA,qBAAqB;EACrB,yBAAyB;EACzB;EACA;MACI,YAAY;EAChB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,qCAAqC;;IAErC,gCAAgC;IAChC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".login-container {\n    padding-top: 135px;\n    color: #000;\n    text-align: center;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: normal;\n    top: 0;\n    width: 100%;\n    \n    display: flex;\n   \n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center 0;\n    flex-direction: column;\n    align-items: center;\n    height: 100vh;\n    filter: grayscale(20%);\n    box-sizing: border-box;\n  }\n  \n  .input-group {\n    margin-bottom: 15px;\n  }\n  \n  .login-input {\n    width: 327px;\n    height: 60px;\n    padding: 16px 24px 16px 24px;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 16px;\n    border: 2px solid var(--Off-Black, #1d1d1f);\n    background: var(--Off-White, #fafafc);\n    font-size: 24px;\n  }\n  .login-input:focus{\n  border-color: #922c2e;\n  border: 2px solid #922c2e;\n  }\n  input:focus {\n      outline:none;\n  }\n  .login-button {\n    width: 325px;\n    height: 60px;\n    display: inline-flex;\n    padding: 14px 32px;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n    border-radius: 16px;\n    background: var(--Off-Black, #1d1d1f);\n  \n    color: var(--Off-White, #fafafc);\n    /* Heading/H3 Bold */\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 32px;\n    /* 133.333% */\n  }\n  \n  .login-button:hover {\n    background-color: #922c2e;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
